import React from "react";

import { Button2 } from "@/ui2/atoms/Button";

import { getAutomationDataAttr } from "../../../../utils/automationUtils";
import { VideoViewBase } from "../index";

import "../styles.scss";

export const AllowAVStep = (props) => {
  const { startPreview } = props;

  let content = (
    <div className="position-relative GuidedVideoCall__wrapper">
      <div className="GuidedVideoCall__allow_message text-white fs-18 tw:font-bold">
        <p>
          Select Allow to let aptihealth use your mic and camera for calls and meetings on this
          browser.
        </p>
        <p className="fs-14">
          When you do, we’ll turn your devices on for a moment to set them up.
        </p>
        <Button2
          {...getAutomationDataAttr("AllowAVStep_allow")}
          className="tw:mt-12!"
          onPress={startPreview}
        >
          Allow
        </Button2>
      </div>
    </div>
  );

  return <VideoViewBase content={content} {...props} />;
};
